import { Component, OnInit} from "@angular/core";
import { EventTypes, IBottomNavigation, SaleSteps } from "common/models";
import { SharedService } from "common/services";
import { Resource, ADPResourceService as ResourceService } from "digital-core";

@Component({
  selector: "gsp-bottom-nav-bar",
  templateUrl: "bottom-nav-bar.component.html",
  styleUrls: ["bottom-nav-bar.component.css"],
})
export class BottomNavBarComponent implements OnInit {
  bottomNavData: IBottomNavigation;
  currentStep: SaleSteps;
  continueButtonResource : Resource;
  backButtonResource : Resource;
  cancelButtonResource : Resource;
  isContinueDisabled: boolean = false;

  constructor(
    private sharedService: SharedService,
    public resourceService: ResourceService
  ) {
    this.bottomNavData = {
      ShowBack: true,
      ShowCancel: true,
      ShowContinue: true,
      DisableContinue: true,
      ShowNav: true,
    };
    this.sharedService.bottomNavClick.subscribe(
      (result) => (this.currentStep = result.currentStep)
    );
  }

  ngOnInit() {
    this.continueButtonResource =this.resourceService.getViewResourceObject('Global_Text_SaveAndContinueButton');
    this.backButtonResource =this.resourceService.getViewResourceObject('Global_Text_BackButton');
    this.cancelButtonResource =this.resourceService.getViewResourceObject('Global_Text_CancelButton');
    const IsCancelButtonEnabled = this.resourceService.getPortalSetting('IsCancelButtonEnabled');
    this.sharedService.bottomNavDisableContinue.subscribe(isDisabled => {
      this.isContinueDisabled = isDisabled;
    });
    this.sharedService.bottomNavData.subscribe((bottomNavData) => {
      if (!bottomNavData.CurrentStep || (bottomNavData.CurrentStep && bottomNavData.CurrentStep === this.currentStep)) {
        bottomNavData.ShowCancel = (!!IsCancelButtonEnabled ? JSON.parse( IsCancelButtonEnabled.Value) : true ) &&  bottomNavData.ShowCancel;
        if(this.isContinueDisabled) {
          this.continueButtonResource.Disabled = true;
        } else {
          this.continueButtonResource.Disabled = bottomNavData.DisableContinue;
        }
        this.continueButtonResource.Hidden =!bottomNavData.ShowContinue;
        this.backButtonResource.Hidden =!bottomNavData.ShowBack;
        this.cancelButtonResource.Hidden = !bottomNavData.ShowCancel;
        this.bottomNavData = bottomNavData;
      }
    });
  }

  back() {
    this.sharedService.bottomNavClick.next({
      eventType: EventTypes.Back,
      currentStep: this.currentStep,
    });
  }

  cancel() {
    this.sharedService.bottomNavClick.next({
      eventType: EventTypes.Cancel,
      currentStep: this.currentStep,
    });
  }

  continue() {
    this.sharedService.bottomNavClick.next({
      eventType: EventTypes.Continue,
      currentStep: this.currentStep,
    });
  }
}
